import { useState, useEffect } from 'react';
import { useStorage64Latin , useWindowSize } from 'hooks';
import { CURRENT_GIFT_TABLE } from 'constants/storage64';
import { Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import { CustomIcon, Modal, ModalQR } from 'components';
import { getGiftTableLink } from 'services/commons';
import { Card, MinimalistCard } from 'components/Cards';
import qrIcon from 'assets/img/qr-icon.svg';
import barcodePrimary from 'assets/img/codbar.png';
import barcodeSecond from 'assets/img/pistbar.png';
import barcodeSecond2 from 'assets/img/scanToStore.svg';
import _isEmpty from 'lodash/isEmpty';
import { Link , useHistory } from 'react-router-dom';
import { decodeStorage } from 'functions/storageBase64';
import PrintQr from './PrintQr';
import ScannerQr from './ScannerQr';
import { VARIANTS } from './config';
import styles from './styles.module.scss';

const TITLE = 'Imprime tu código para que lo incluyas en tus invitaciones';
const PRINT_LABEL = 'Imprimir aquí';
const ALT = 'Imprimir código QR';

export function PrintQR({ variant = VARIANTS.DEFAULT ,getOpenModal = false , closeModal=()=>{} }) {
  // const [giftTableInfo] = useStorage64Latin(CURRENT_GIFT_TABLE, {});
  const giftTableInfo = decodeStorage('GIFT_TABLE_DATA');
  const [url, setUrl] = useState(null);
  const [showModalScannerQr, setShowModalScannerQr] = useState(false);
  const [showModalPrinQr, setShowModalPrinQr] = useState(false);
  const history = useHistory()
  const [, { isMobile }] = useWindowSize();
  const handleOpenPrintQr = () => {
    setShowModalPrinQr(true);
  };

  const handleClosePrintQr = () => {
    setShowModalPrinQr(false);
    closeModal(false);
  };

  const handleOpenModal = () => {
    setShowModalScannerQr(true);
  };


  
  useEffect(() => {
    if (getOpenModal ) setShowModalPrinQr(true);
  }, [getOpenModal]);
  
  const handleCloseModal = () => {
    setShowModalScannerQr(false);
  };

  useEffect(() => {
    if (!_isEmpty(giftTableInfo)) {
      setUrl(getGiftTableLink(giftTableInfo));
    }
  }, [giftTableInfo]);

  const isMinimalist = variant === VARIANTS?.MINIMALIST;
  const renderTitle = (
    <h6
      className={classNames(
        'text-center',
        isMinimalist && styles?.title,
        isMinimalist ? 'mb-1' : 'mb-4'
      )}
    >
      {TITLE}
    </h6>
  );

  const renderPrintButton = (
    <h6
      className={classNames(
        'font-weight-bold text-primary text-center pointer',
        isMinimalist && styles?.printButton,
        isMinimalist && 'm-0'
      )}
    >
      <button type="button" className="btn-clean" onClick={handleOpenPrintQr}>
        {PRINT_LABEL}
      </button>
    </h6>
  );

  const renderImageQRButton = (
    <h6
      className={classNames(
        'font-weight-bold text-primary text-center pointer',
        isMinimalist && styles?.printButton,
        isMinimalist && 'm-0'
      )}
    >
      <button type="button" className="btn-clean" onClick={handleOpenPrintQr}>
        <img src={qrIcon} alt={ALT} className={styles?.icon} />
      </button>
    </h6>
  );

  const defaultRender = (
    <Card className="p-4">
      <Row>
        <Col
          lg={6}
          className="pb-5 pt-1 pb-md-4 pt-md-0 p-lg-0 d-flex align-items-center justify-content-center"
        >
          {/* <img src={qrIcon} alt={ALT} /> */}
          {renderImageQRButton}
        </Col>
        {/* <Col lg={6}>
          {renderTitle}
          {renderPrintButton}
        </Col> */}
      </Row>
    </Card>
  );

  const minimalistRender = (
    <MinimalistCard className={styles?.printQrMinimalist}>
      <div className={styles?.content}>
        <div>
          {/* {renderTitle}
          {renderPrintButton} */}
          {renderImageQRButton}
        </div>
        {/* <div>
          <img src={qrIcon} alt={ALT} className={styles?.icon} />qqqq
        </div> */}
      </div>
    </MinimalistCard>
  );

  const extraSmallRender = (
    <CustomIcon onClick={() => history.push('/compartir-mesa')} variant="square" icon={qrIcon} />
  );

  const primaryRender = (
    <>
      {/* <div className={styles?.qrPrimary} onClick={handleOpenModal}>
          <Row className="justify-content-center">
              <div>
                  <p className="m-0">¿Estás en la tienda Sears?</p>
              </div>
          </Row>
          <Row className="justify-content-center">
              <div className="d-flex align-items-center">
                  <img src={barcodePrimary} alt={ALT} style={{ width: '60px', marginRight: '2px' }} />
                  <img src={barcodeSecond} alt={ALT} style={{ width: '60px', height: '60px', marginLeft: '2px' }} />
              </div>
          </Row>
          <Row className="justify-content-center p-1">
              {!isMobile ? (
                <Link onClick={handleOpenModal}>Escanea el código de barras del producto</Link>
                ):(
                  <Link to="/escanear-productos">Escanea el código de barras del producto</Link>
                  )}

          </Row>
      </div> */}

      <div className={styles?.qrPrimary2} onClick={handleOpenModal}>
          <img src={barcodeSecond2} alt={ALT}  />
          <div className={styles?.contTitles}>
              <div className={styles?.title}>Agrega productos con tu celular.</div>
              <div className={styles?.linkRed} >Escanear</div>
          </div>
      </div>
    </>
  );

  const notRender = (
    <></>
  );
  const RENDERS_BY_VARIANT = {
    [VARIANTS.DEFAULT]: defaultRender,
    [VARIANTS.MINIMALIST]: minimalistRender,
    [VARIANTS.EXTRA_SMALL]: extraSmallRender,
    [VARIANTS.PRIMARY]: primaryRender,
    [VARIANTS.NONE]: notRender,
  };

  const handlerFestejados = (giftTableInfo) =>{
    const festejados = giftTableInfo?.celebrate_labels?.map(c => c.label?.value?.trim());
    return  festejados ? festejados.join(' & ') : giftTableInfo?.festejados ; 
  }

  return (
    <>
      <Modal
        title="Escanear productos"
        titleClassName="col-md-12 offset-md-1"
        show={showModalScannerQr}
        onClose={handleCloseModal}
        withActionButtons={false}
      >
        <ScannerQr />
      </Modal>
      <ModalQR
          size="lg"
          title={giftTableInfo?.name || giftTableInfo?.nombre}
          titleClassName="col-md-6 offset-md-3"
          show={showModalPrinQr}
          onClose={handleClosePrintQr}
          withActionButtons={false}
          titleHeader='Compartir mesa'
          titleHeaderClassName="col-md-6 offset-md-3"
      >
        <div className={`modalContent ${styles?.modalContent}`}>
          <PrintQr url={url} title={giftTableInfo?.name || giftTableInfo?.nombre} evento={giftTableInfo?.name || giftTableInfo?.nombre} celebrate={handlerFestejados(giftTableInfo)} image={giftTableInfo?.image}/>
        </div>
      </ModalQR>
      {RENDERS_BY_VARIANT[variant]}
    </>
  );
}

export default PrintQR;
